import { useOptionMaxDailyStockNum as useMaxDailyStockNum } from "@/components/features/items/edit/option/_shared/ui/components/max-daily-stock-num/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionMaxDailyStockNum = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { maxDailyStockNum } = viewModel;

	return useMaxDailyStockNum({ maxDailyStockNum, onSetViewModel });
};
